export default __webpack_public_path__ + "static/media/EU-Privacy-Policy-Tapt-By-Hatch.d7986a85.pdf";